export function convertDate(date){
    if (!date) return;

    // Format the date into a human-readable string
    try {
        const parsedDate = new Date(date);
        const options = {
            timeZone: 'Europe/Berlin',
            year: 'numeric',
            month: 'short',
            day: 'numeric'
          };
        return Intl.DateTimeFormat('de-DE', options).format(parsedDate);
    } catch(e){
        return date;
    }
}

export function convertDateWitDetail(date){
    if (!date) return;

    // Format the date into a human-readable string
    try {
        const parsedDate = new Date(date);
        const options = {
            timeZone: 'Europe/Berlin',
            year: 'numeric',
            month: 'short',
            day: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
            second: 'numeric'
        };
        return new Intl.DateTimeFormat('de-DE', options).format(parsedDate);
    } catch(e) {
        return date;
    }
}

export function convertDateForWishlist(date){
    if (!date) return;

    try {
        const parsedDate = new Date(date);
        const options = {
            timeZone: 'Europe/Berlin',
            year: 'numeric',
            month: 'short',
            day: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
        };
        return  new Intl.DateTimeFormat('de-DE', options).format(parsedDate);
    } catch(e){
        return date;
    }
}